module.exports = __webpack_public_path__ + "img/00013.0fee7d9e.webp";